// extracted by mini-css-extract-plugin
export var paginationContainer = "_3r-0";